/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalized_Focus_ExperienceInputs */

const en_personalized_focus_experience = /** @type {(inputs: Personalized_Focus_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom focus experience`)
};

const ar_personalized_focus_experience = /** @type {(inputs: Personalized_Focus_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تجربة تركيز مخصصة`)
};

const de_personalized_focus_experience = /** @type {(inputs: Personalized_Focus_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Individuelles Fokus-Erlebnis`)
};

const es_personalized_focus_experience = /** @type {(inputs: Personalized_Focus_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experiencia personalizada de concentración`)
};

const fr_personalized_focus_experience = /** @type {(inputs: Personalized_Focus_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expérience de concentration personnalisée`)
};

const it_personalized_focus_experience = /** @type {(inputs: Personalized_Focus_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esperienza di concentrazione personalizzata`)
};

const ja_personalized_focus_experience = /** @type {(inputs: Personalized_Focus_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集中体験のカスタマイズ`)
};

const ko_personalized_focus_experience = /** @type {(inputs: Personalized_Focus_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`커스텀 집중 환경`)
};

const pt_br_personalized_focus_experience = /** @type {(inputs: Personalized_Focus_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experiência de foco personalizada`)
};

const ru_personalized_focus_experience = /** @type {(inputs: Personalized_Focus_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройка режима фокусировки`)
};

const th_personalized_focus_experience = /** @type {(inputs: Personalized_Focus_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ประสบการณ์การโฟกัสแบบกำหนดเอง`)
};

const tr_personalized_focus_experience = /** @type {(inputs: Personalized_Focus_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Özel odaklanma deneyimi`)
};

const zh_cn_personalized_focus_experience = /** @type {(inputs: Personalized_Focus_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`个性化专注体验`)
};

const zh_tw_personalized_focus_experience = /** @type {(inputs: Personalized_Focus_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`個性化專注體驗`)
};

/**
* | output |
* | --- |
* | "Custom focus experience" |
*
* @param {Personalized_Focus_ExperienceInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const personalized_focus_experience = /** @type {((inputs?: Personalized_Focus_ExperienceInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalized_Focus_ExperienceInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_personalized_focus_experience(inputs)
	if (locale === "ar") return ar_personalized_focus_experience(inputs)
	if (locale === "de") return de_personalized_focus_experience(inputs)
	if (locale === "es") return es_personalized_focus_experience(inputs)
	if (locale === "fr") return fr_personalized_focus_experience(inputs)
	if (locale === "it") return it_personalized_focus_experience(inputs)
	if (locale === "ja") return ja_personalized_focus_experience(inputs)
	if (locale === "ko") return ko_personalized_focus_experience(inputs)
	if (locale === "pt_br") return pt_br_personalized_focus_experience(inputs)
	if (locale === "ru") return ru_personalized_focus_experience(inputs)
	if (locale === "th") return th_personalized_focus_experience(inputs)
	if (locale === "tr") return tr_personalized_focus_experience(inputs)
	if (locale === "zh_cn") return zh_cn_personalized_focus_experience(inputs)
	return zh_tw_personalized_focus_experience(inputs)
});